import { render, staticRenderFns } from "./GamePepper.vue?vue&type=template&id=e201bd5c&"
import script from "./GamePepper.vue?vue&type=script&lang=js&"
export * from "./GamePepper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports